import { FacebookAuthProvider } from 'firebase/auth';

const facebookAuthProvider = new FacebookAuthProvider();

// https://developers.facebook.com/docs/permissions/reference/email
facebookAuthProvider.addScope('email');

// https://developers.facebook.com/docs/permissions/reference/public_profile
// Allows to read:
// id
// first_name
// last_name
// middle_name
// name
// name_format
// picture
// short_name
facebookAuthProvider.addScope('public_profile');

// re-request scope in case of the user denied e.g. email
facebookAuthProvider.setCustomParameters({ auth_type: 'rerequest' });

export default facebookAuthProvider;
